<template>
  <IdleTracker>
    <b-navbar v-if="$store.getters['session/isLogged']" class="navbar-forum-commom navbar-forum" sticky toggleable="xl">
      <div class="navbar-items-align">
				<b-nav-item class="d-block my-auto pr-2" @click="onBackButtonClick" v-if="showBackButton">
					<base-icon src="/static-appopensalud/img/icons/morillas-svg-icons/primary/caret.svg" svgClasses="rotate-180" width="20" height="20"/>
				</b-nav-item>
        <b-navbar-brand @click.stop="goPatientMenu()" class="cursor-pointer mx-auto mx-lg-0"><img class="navbar-brand-img" :style="getLogoStyles" :src="getLogo"/></b-navbar-brand>
        <div v-if="!showInSubmenu" class="pointer push-notifications-mobile" @click="showPushNotifications"><b-icon-bell class="pointer" scale="1.3"></b-icon-bell><span v-if="$store.state.forum.numberPushNotifications > 0" class='badge-forum badge-pill'>{{$store.state.forum.numberPushNotifications}}</span></div>
        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
      </div>
      
      <b-collapse class="navCollapse" id="nav-collapse">
        <b-navbar-nav class="ml-auto navbar-submenu">
        <b-nav-item v-if="showInSubmenu" class="pointer" @click="showPushNotifications"><b-icon-bell class="pointer" scale="1.3"></b-icon-bell><span v-if="$store.state.forum.numberPushNotifications > 0" class='badge badge-pill'>{{$store.state.forum.numberPushNotifications}}</span></b-nav-item>
        <b-nav-item v-if="showInSubmenu"><b-form-group class="search-navbar" v-if="!$store.state.forum.hideSearcher"><component :is="inWhoInSection ? 'base-button' : 'b-form-input'" v-model="$store.state.forum.entrySearchValue" @click="searchModalClick" @keyup="searchModal" :placeholder="searchPlaceholder">{{inWhoInSection ? $t('searchWhoInPlaceholder') : null}}</component></b-form-group></b-nav-item>
        <b-nav-item v-if="!showInSubmenu"><base-button outline fitContent>{{$store.state.forum.userBasicInfo.nick}}</base-button></b-nav-item>
        <b-nav-item v-if="!showInSubmenu" v-b-toggle.nav-collapse><lang-selector enablePortuguese style="width: max-content;" class="d-inline-block"></lang-selector></b-nav-item>
        <b-nav-item v-b-toggle.nav-collapse><base-button outline fitContent @click="createNewPost">{{$store.getters['forum/forumUserIsAdminRole'] ? $t('createNewEntry') : newPostTitle}}</base-button></b-nav-item>
        
        <!--Showing only in lg mode-->
        <b-nav-item v-if="showInSubmenu" class="my-auto" style="margin-right: 1rem;">
            <dropdown enablePortuguese showLanguageSelector class="dropdown" showAsNavbarBtn :title="$store.state.forum.userBasicInfo.nick" @logOff="logOff" :items="dropdownLoginItems" />
        </b-nav-item>       
        <div v-if="!showInSubmenu">
          <b-nav-item v-b-toggle.nav-collapse @click="$router.push(getPathUrl('panel/perfil')).catch(() => {})"><base-button outline fitContent>{{$t('controlPanel')}}</base-button></b-nav-item>
          <b-nav-item v-b-toggle.nav-collapse @click="logOff"><base-button outline fitContent>{{$t('logOff')}}</base-button></b-nav-item>
        </div>
      </b-navbar-nav>
    </b-collapse>
  </b-navbar>
  <b-navbar sticky v-if="!$store.getters['session/isLogged']" class="navbar-forum-commom navbar-login">
    <div class="navbar-items-align">
        <b-nav-item class="d-block my-auto pr-2" @click="onBackButtonClick" v-if="showBackButton">
					<base-icon src="/static-appopensalud/img/icons/morillas-svg-icons/primary/caret.svg" svgClasses="rotate-180" width="20" height="20"/>
				</b-nav-item>
      <b-navbar-brand @click.stop="goPatientMenu()" class="cursor-pointer mx-auto mx-lg-0"><img class="navbar-brand-img" :style="getLogoStyles" :src="getLogo"/></b-navbar-brand>
    </div>
    <b-nav-item class="ml-auto" v-if="showSearchNavbarOutside">
      <b-form-group class="search-navbar" v-if="!$store.state.forum.hideSearcher"><component :is="inWhoInSection ? 'base-button' : 'b-form-input'" v-model="$store.state.forum.entrySearchValue" @click="searchModalClick" @keyup="searchModal" :placeholder="searchPlaceholder">{{inWhoInSection ? $t('searchWhoInPlaceholder') : null}}</component></b-form-group>
    </b-nav-item>
    <base-button @click="logIn()" class="btn btn-primary fixed-padding-btn-forum" :class="{'ml-auto': !showSearchNavbarOutside}"><span>{{ $t('accessBtn') }}</span>
      <base-icon src="/static-appopensalud/img/icons/morillas-svg-icons/primary/arrow.svg" color="white"/>
    </base-button>
  </b-navbar>
  <b-nav-item class="search-mobile" v-if="(!$store.getters['session/isLogged'] && !showSearchNavbarOutside) || ($store.getters['session/isLogged'] && !showInSubmenu && !$store.state.forum.hideOutsideSearchBar)">
    <b-form-group class="search-navbar" v-if="!$store.state.forum.hideSearcher"><component :is="inWhoInSection ? 'base-button' : 'b-form-input'" v-model="$store.state.forum.entrySearchValue" @click="searchModalClick" @keyup="searchModal" :placeholder="searchPlaceholder">{{inWhoInSection ? $t('searchWhoInPlaceholder') : null}}</component></b-form-group>
  </b-nav-item>
  <b-modal id="modalForumNotifications" v-model="$store.state.forum.showPushNotificationsModal" centered hide-footer scrollable>
    <template slot="modal-title">
      <b-icon-gear id="showPushNotificationsOptions" @click.stop="" class="pointer" scale="1.3"></b-icon-gear>
      <span class="notifications-title-modal">{{$t('notifications')}}</span>
      <b-popover id="popoverPushNotifications" target="showPushNotificationsOptions" triggers="click" placement="right">
        <b-row class="more-options-row">
          <b-col cols="12" v-if="$store.state.forum.pushNotifications && $store.state.forum.pushNotifications.length > 0" @click="showConfirmDelete = true"><div class="more-options-item"><b-icon-calendar-x></b-icon-calendar-x> <span>{{$t('removeHistory')}}</span></div></b-col>
          <b-col cols="12" @click.stop="goNotificationsSetting"><div class="more-options-item"><b-icon-sliders></b-icon-sliders> <span>{{$t('settingNotifications')}}</span></div></b-col>
        </b-row>
      </b-popover>
    </template>
    <div v-if="$store.state.forum.pushNotifications && $store.state.forum.pushNotifications.length > 0">
      <div @click="pushNotificationClick(item.entryId, item.sectionId)" :class="{pushNotificationBox: true, pendingRead: !item.readed, markedSection: item.markedSectionId === item.sectionId}" v-for="(item, index) in $store.state.forum.pushNotifications" :key="index">
        <div class="pushNotificationMessage" v-html="item.message"></div>
        <div class="datePushNotification" v-html="getTimeAgoFromDate(item.date)"></div>
      </div>
    </div>
    <div class="noPendingNotifications" v-else>
      {{$t('noPendingPushNotifications')}}
    </div>
  </b-modal>
  <loading-anim v-if="$store.state.loading" :active="$store.state.loading" fullScreen></loading-anim>
  <arrow-up></arrow-up>
  <router-view v-if="$store.state.forum.showMainPage"></router-view>
  <!--searcher modal-->
  <forum-searcher :search="search"></forum-searcher>
  <forum-activity-search v-if="showActivitySearch" v-model="showActivitySearch"></forum-activity-search>
  <base-dialog :value="showConfirmDelete" :okFn="() => { removePushNotifications(); showConfirmDelete = false; }" :cancelFn="() => { showConfirmDelete = false; }" :okBtnText="$t('yes')" :cancelBtnText="$t('no')" :content="$t('removePushNotifications')"></base-dialog>
  <base-modal hideClose noCloseOnBackdrop noCloseOnScape :value="$store.state.forum.userBasicInfo.firstAccess" :title="getModalFirstAccessTitle" @hidden="$store.state.forum.userBasicInfo.firstAccess = false">
    <div class="mb-4">{{$t('firstAccessForum')}}</div>
    <div class="mb-4">{{$t('firstAccessNickForum')}}</div>
    <div class="mb-4"><base-input v-model="$store.state.forum.userBasicInfo.nick"></base-input></div>
    <div class="mb-4"><b>{{$t('firstAccessFooterForum')}}</b></div>
    <div class="text-center"><base-button @click="saveNewNick">{{$t('continue')}}</base-button></div>
  </base-modal>
  <b-modal no-close-on-backdrop hide-header-close no-close-on-esc size="lg" v-model="showMonthlyAdviceModal" centered hide-footer>
    <div class="text-center">
      <div>{{$t('monthlyAccessAdvice')}}</div>
      <div class="mt-5"><base-button @click="resetMonthlyAccessAdvice">{{$t('continue')}}</base-button></div>
    </div>
  </b-modal>
</IdleTracker>
</template>

<script>
import { BFormGroup, BFormInput, BIcon, BIconStarFill, BIconStar, BIconStarHalf, BNavbar, BNavbarBrand, BNavbarToggle, BCollapse, BNavbarNav, BDropdownItem, BNavItemDropdown, BNavItem, BContainer, BRow, BButton, BTabs, BTab, BCol, BModal, BPopover } from 'bootstrap-vue'
import Dropdown from '@/components/base/dropdown/Dropdown'
import BaseModal from '@/components/base/BaseModal'
import ForumSearcher from '@/components/views/healthy-community/forum/ForumSearcher'
import LangSelector from '@/components/base/LangSelector'
import LoginFormModal from '@/components/base/modals/LoginFormModal'
import ForumControlPanel from '@/components/views/healthy-community/forum/ForumControlPanel'
import forumMixin from '@/mixins/forum.mixin'
import layoutMixin from '@/mixins/layout.mixin'
import VueBootstrapTypeahead from 'vue-bootstrap-typeahead'
import BaseDialog from '@/components/base/BaseDialog'
import ForumActivitySearch from '@/components/views/healthy-community/forum/ForumActivitySearch'
import { HEALTHY_INFORMATION_HEALTH_COMMUNITY_SECTION, FORUM_HEALTH_COMMUNITY_SECTION } from '../../constants/healthyCommunitySections'
import BaseInput from '../base/forms/BaseInput.vue'
import BaseButton from '../base/buttons/BaseButton.vue'
import ArrowUp from '@/components/shared/ArrowUp'
import { country } from '@/helpers/global.helpers'
import { BLUE_COLOUR } from '@/constants/colours'
import IdleTracker from '@/components/utils/IdleTracker'

export default {
  name: 'forumNavbar',
  components: {
    BIcon,
    BIconStarFill,
    BIconStar,
    BIconStarHalf,
    BNavbar,
    BNavbarBrand,
    BNavbarToggle,
    BCollapse,
    BNavbarNav,
    BDropdownItem,
    BNavItemDropdown,
    BNavItem,
    BContainer,
    BCol,
    BRow,
    BButton,
    BTabs,
    BTab,
    BFormInput,
    BFormGroup,
    BModal,
    BPopover,
    BaseModal,
    VueBootstrapTypeahead,
    Dropdown,
    ForumActivitySearch,
    ForumControlPanel,
    'lang-selector': LangSelector,
    LoginFormModal,
    'loading-anim': () => import('@/components/utils/LoadingAnim').then(m => m.default),
    ForumSearcher,
    BaseDialog,
    BaseInput,
    BaseButton,
    ArrowUp,
		IdleTracker
  },
  computed: {
    showInSubmenu () {
      return window.innerWidth >= 1200
    },
    getModalFirstAccessTitle () {
      return this.$t('welcomeTo', [location.href.toLowerCase().indexOf('comunidadsaludable') > -1 ? this.$t('healthyCommunityFirstAccessTitle') : this.$t('patientsLikeYou')])
    },
    noMarginBottom () {
      return location.pathname.indexOf('/panel') > -1
    },
    showSearchNavbarOutside () {
      return window.innerWidth >= 1485
    },
    showHealthyCommunityBanner () {
      return location.href.toLowerCase().indexOf('comunidadsaludable') > -1 && !this.$route.params.forumSection
    },
    showSectionBanner () {
      return location.href.toLowerCase().indexOf('comunidadsaludable') > -1 && (this.inWhoInSection || this.$store.state.forum.sectionId === HEALTHY_INFORMATION_HEALTH_COMMUNITY_SECTION || this.$store.state.forum.sectionId === FORUM_HEALTH_COMMUNITY_SECTION)
    },
    getSectionName () {
      return this.getForumSectionTitle(this.$store.state.forum.sectionId)
    },
    showMonthlyAdviceModal () {
      return !this.$store.state.forum.userBasicInfo.firstAccess && this.showMonthlyAdvice
    },
    newPostTitle () {
      return this.inWhoInSection ? this.$t('proposeNewActivity') : this.$t('proposeNewPost')
    },
    searchPlaceholder () {
      return this.inWhoInSection ? this.$t('searchWhoInPlaceholder') : this.$t('searchPlaceholder')
    }
  },
  props: {
  },
  mounted () {
  },
  data () {
    return {
      dropdownLoginItems: [
        {
          title: this.$t('controlPanel'),
          href: this.getPathUrl('panel/perfil')
        },
        {
          title: this.$t('logOff'),
          click: 'logOff'
        }
      ],
      showNewPostForm: false,
      showLoginForm: false,
      search: {
          display: 'none',
          timer: null,
          categories: [],
          tags: [],
          entries: [],
          diseases: []
      },
      showActivitySearch: false,
      showConfirmDelete: false,
      showMonthlyAdvice: localStorage.getItem('forumNextDateMonthlyAccessAdvice') ? new Date(localStorage.getItem('forumNextDateMonthlyAccessAdvice')) < new Date() : true,
			BLUE_COLOUR
		}
  },
  created () {
    if (this.$store.getters['session/isLogged'] && !this.$store.state.forum.userBasicInfo.userAspId) {
      this.getUserBasicInfo()
    }
    if (this.$route.params.forumSection) {
      this.$store.state.forum.sectionId = this.getForumSectionByPath(this.$route.params.forumSection)
    }
  },
  mixins: [forumMixin, layoutMixin],
  methods: {
    searchModal () {
      this.search.display = 'initial'
      clearTimeout(this.search.timer)

      this.search.timer = setTimeout(() => {
          this.getSearch()
      }, 800)
    },
    searchModalClick () {
      if (this.inWhoInSection) {
        if (!this.$store.state.forum.numEntries && !Object.keys(this.$store.state.forum.activityFilters).length) {
          this.$store.dispatch('showInfoAlert', this.$t('noActivitiesToSearch'))
          return
        }
        this.showActivitySearch = true
      } else {
        window.scrollTo(0, 0)
        this.search.display = 'initial'
        this.getSearch()
      }
    },
    saveNewNick () {
      if (!this.$store.state.forum.userBasicInfo.nick) {
        this.$store.dispatch('showDangerAlert', this.$t('emptyNick'))
        return
      }
      this.$api.put('/Forum/UpdateNick', null, {params: {nick: this.$store.state.forum.userBasicInfo.nick}}).then((response) => {
        if (response.data) {
          this.$store.dispatch('showSuccessAlert', this.$t('changesPerformedCorrectly'))
          this.resetMonthlyAccessAdvice()
          this.$store.state.forum.userBasicInfo.firstAccess = false
        } else {
          this.$store.dispatch('showDangerAlert', this.$t('defaultErrorMessage'))
        }
      })
    },
    getSearch () {
      this.$api.get('/Forum/Search', {params: {search: this.$store.state.forum.entrySearchValue, sectionId: this.$store.state.forum.sectionId}}).then((response) => {
        if (response.data) {
          this.search.entries = response.data.entries
          this.search.categories = response.data.categories
          this.search.tags = response.data.tags
          this.search.diseases = response.data.diseases
        } else {
          this.$store.dispatch('showDangerAlert', this.$t('defaultErrorMessage'))
        }
      })
    },
    removePushNotifications () {
      this.$api.delete('/Forum/RemovePushNotifications').then((response) => {
        this.clearPushNotifications()
      })
    },
    pushNotificationClick (entryId, sectionId) {
      if (entryId) {
        this.$router.push(this.getPathUrl(entryId, this.getForumPathBySectionId(sectionId)))
        this.clearPushNotifications()
      }
    },
    clearPushNotifications () {
      this.$store.state.forum.pushNotifications = []
      this.$store.state.forum.userBasicInfo.pushNotificationsSectionId = []
      this.$store.state.forum.showPushNotificationsModal = false
      this.$store.state.forum.numberPushNotifications = 0
    },
    goNotificationsSetting () {
      this.$router.push({ name: `panel-administracion${location.href.indexOf('comunidadsaludable') > -1 ? '-healthycommunity' : ''}`, params: { section: 'notificaciones' } })
      this.$store.state.forum.showPushNotificationsModal = false
    },
    resetMonthlyAccessAdvice () {
      localStorage.setItem('forumNextDateMonthlyAccessAdvice', new Date(new Date().setMonth(new Date().getMonth() + 1)))
      this.showMonthlyAdvice = false
    },
		goOpenhealth () {
      location.href = this.$store.getters['forum/forumUserIsProfessionalRole'] ? `https://app-360.opensalud.es/${this.$i18n.locale}/HomeProfesional` : `https://${location.href.indexOf('test') > -1 ? 'pruebas-' : ''}360.opensalud.${country}/${this.$store.getters['forum/forumUserIsPatientRole'] ? 'patient' : ''}`
    },
		removeSearch () {
      this.$store.state.forum.showingSearch = false
      this.$store.state.forum.searchType = false
      this.$store.state.forum.searchId = false
      this.$store.state.forum.entriesPageNumber = 0
      this.loadForumEntries()
    },
		onBackButtonClick () {
			if (this.$route.name === 'comunidadsaludable') {
				this.goOpenhealth()
			} else if (this.$route.name === 'foro' && this.inHealthyCommunity && !this.$store.state.forum.showingSearch) {
				this.$router.push(this.getHealthyCommunityPathUrl())
			} else if (this.$route.name === 'foro' && this.$store.state.forum.showingSearch) {
				this.removeSearch()
			} else {
				this.$router.go(-1)
			}
		}
  }
}
</script>

<style lang="scss">
@import "static-appopensalud/css/public/views/forum.scss";
.badge-forum {
  position: absolute;
  font-size: xx-small;
  margin-left: -5px;
  margin-top: -10px;
  background-color: $blue;
  color: white;
}
.navCollapse {
    position: fixed !important;
    top: 4rem;
    right: 1rem !important;
    flex-basis: 100%;
    flex-grow: 1;
    align-items: center;
    @include screen-xl-grid {
      position: sticky !important;
    }
  }
.nav-item{
  margin-right: 0 !important;
}

.nav-item {
  @include media(mobile, tablets) {
    padding: 0rem 2rem;
  }
}

@include screen-xl-grid {
  .navbar-forum-commom.navbar-expand-xl .navCollapse {
    display: -webkit-box !important;
    display: -ms-flexbox !important;
    display: flex !important;
    -ms-flex-preferred-size: auto;
    flex-basis: auto;
  }
}

.navbar-forum-commom {
  padding: 2rem 5rem;
  background-color: $body-bg;
  @include desktop-xl{
    padding: 2rem 15rem;
  }
}

.c-header{
  border-bottom: 1px solid #ddd;
}

.logo {
  height: 36px !important;
  padding: 0;
  margin: 0 !important;
  @include media(mobile) {
    height: 29px !important;
  }
}

.access-btn{
    @media screen and (max-width: 768px) {
      color: #3238C4 !important;
      background-color: transparent !important;    
    }
  }

.show-admin-btn {
  @include media(mobile, tablets) {
    display: initial;
  }
}

.dialog-search{
  position: absolute !important;
  top: 9vh !important;
  width: 50vw !important;
  left: 25vw !important;
  z-index: 10 !important;
  max-width: 50vw !important;
  @media (max-width: 1250px) {
    width: 98vw !important;
    max-width: 98vw !important;
    left: 0 !important;
    top: 14vh !important;
    margin-left: 3px !important;
  }
}

@include screen-xl-grid-max {
  .navbar.navbar-light.navbar-expand-xl{
    padding-right: 1rem !important;
    padding-left: 1rem !important;
 }
 .navbar ul.navbar-nav:not(.outside-collapse){
  -webkit-transition: all .5s ease !important;
  transition: all .5s ease !important;
  background-color: #eee !important;
  border-radius: 23px !important;
  -webkit-box-shadow: -13px -23px 45px #fff,13px 23px 50px rgba(13,39,80,0.160784) !important;
  box-shadow: -13px -23px 45px #fff,13px 23px 50px rgba(13,39,80,0.160784) !important;
  width: -webkit-fit-content !important;
  width: -moz-fit-content !important;
  width: fit-content !important;
  }
}
@include media(mobile){
 .modal-content{
  width: 100% !important;
 }
}

.nav-log{
  margin-bottom: 0px !important;
}

.navbar-submenu {
  align-items: center !important;
}

.brand-forum{
  cursor: pointer !important;
  margin-right: auto !important;
}

.navbar-login{
  padding-left: 2vw !important;
  padding-right: 2vw !important;
}

.search-mobile{
  padding-bottom: 0px !important;
}

.forum-header-text{
  display: none !important;
  cursor: initial;
  margin-left: 1vw;
  @include screen-xl-grid {
    display: inline-block !important;
  }
}

.search-navbar{
  margin: 0 auto !important;
  input[type="text"] {
    width: 320px !important;
  }
}

.banner-title{
  opacity: 1 !important;
  margin-bottom: 2vh !important;
  background-color: #3238C4 !important;
  color: white !important;
  padding: 2vh 0 !important;
  @include media(mobile) {
    font-size: 1rem !important;
    padding: 2vh 3vw !important;
    margin-bottom: 0px !important;
  }
}

.search-nav-outside-mobile{
  margin-bottom: 2.5vh !important;
}

.pushNotificationBox{
  background-color: $white;
  &:hover{
    cursor: pointer;
    background-color: $gray-400;
    }
    border-radius: 23px; 
    padding: 15px;
    margin: 1% 0; 
}

.datePushNotification{
  font-size: 10px;
  margin-top: 3%;
}

.pushNotificationMessage{
  text-align: justify;
}

.noPendingNotifications{
  text-align: center;
  margin-top: 5%;
}

.push-notifications-mobile{
  position: absolute;
  top: 43px;
  right: 75px;
}

#modalForumNotifications .notifications-title-modal{
  margin-left: auto;
  margin-right: auto;
}

#modalForumNotifications .modal-title{
  display: contents;
}

#modalForumNotifications .modal-header{
  margin: 0 !important;
  width: 100%;
}

.pendingRead {
  background-color: $green;
}

.markedSection {
  background-color: $green;
  animation: blinker-notifications 1.7s cubic-bezier(.5, 0, 1, 1) infinite alternate;
}

@keyframes blinker-notifications { 
  0%{background-color: $green;}
  50%{background-color: initial;}
  100%{background-color: $green;}
}

#popoverPushNotifications {
  max-width: 230px !important;
}

.noMarginBottom {
  margin-bottom: 0px !important;
}
</style>


// WEBPACK FOOTER //
// src/components/layouts/ForumNavbar.vue